import importedAxios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getRefreshPromise } from './token-refresh';

import { ConsoleLogger } from '@/services/logger';
import { logResponse } from './log';
import { KeycloakService } from '@/services/keycloak';
import { updateNetworkStatus } from './network-status';
import { LogLevel } from '@/constants';
//import { cleanupIfUnauthenticated } from '@/services/keycloak';

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new ConsoleLogger(LogLevel.INFO);

export const axiosResponseErrorInterceptorFactory =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (client: AxiosInstance) => (error: any) => {
    updateNetworkStatus(error);
    // update internet status
    const keycloakService = new KeycloakService();

    if (importedAxios.isAxiosError(error)) {
      const originalRequest = error.config as AxiosRequestConfig & {
        _retry?: boolean;
      };

      // log response
      if (error.response) {
        logResponse(error.response);
      }

      if (
        (error.response?.status === 401 || error.response?.status === 403) &&
        !originalRequest._retry
      ) {
        const refreshPromise = getRefreshPromise();
        if (refreshPromise) {
          originalRequest._retry = true;
          // try to get new tokens
          return refreshPromise
            .then((accessToken) => {
              return client({
                ...originalRequest,
                headers: {
                  ...(originalRequest.headers || {}),
                  Authorization: `Bearer ${accessToken}`
                }
              });
            })
            .catch((e) => {
              logger.info(
                'Retrieving new access token failed since keycloak threw an error: ' +
                  e.message
              );
              keycloakService.logoutExternal();
              keycloakService.resetAuthData();
              throw error;
            });
        }
        logger.info(
          `Response code ${error.response?.status}, no refresh token for retry provided`
        );
      } else if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        // still unauthenticated, refresh failed, auto logout
        logger.info('Retried with new accessToken but still failed');
        keycloakService.resetAuthData();
      } else {
        // some other error
        logger.warn(error.toString());
      }
    } else {
      logger.error(error);
    }
    throw error;
  };
